import { makeObservable, observable, action } from 'mobx';

export type ReactionType = 'Easy' | 'Medium' | 'Hard' | 'No clue!';

export class PersonalBestStore {
  selectedReaction: ReactionType | null = null;

  personalBestDecrip: string | null = null;

  personalBestInTenths: number | null = null;

  constructor() {
    makeObservable(this, {
      selectedReaction: observable,
      personalBestDecrip: observable,
      personalBestInTenths: observable,
      setReactionAndPersonalBest: action,
    });
  }

  setReactionAndPersonalBest(
    inputReaction: ReactionType,
    inputPersonalBestDecrip: string,
    inputPersonalBestInTenths: number,
  ) {
    this.selectedReaction = inputReaction;
    this.personalBestDecrip = inputPersonalBestDecrip;
    this.personalBestInTenths = inputPersonalBestInTenths;
  }
}

export const personalBestStore = new PersonalBestStore();
